import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { KommoService } from '../../../../core/services/kommo/kommo.service';

export function pipelineAsyncValidator(kommoService: KommoService): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value;

    if (!value || value === '') {
      return of(null);
    }

    const pipelineId = Number(value);
    if (isNaN(pipelineId) || pipelineId <= 0) {
      return of({ pipelineInvalid: true });
    }

    // Debounce 400ms + switchMap to cancel previous requests
    return timer(400).pipe(
      switchMap(() => kommoService.validatePipeline(pipelineId)),
      map(response => {
        if (response.success && response.data.valid) {
          return null;
        }
        return { pipelineInvalid: true };
      }),
      catchError(() => of({ pipelineValidationError: true }))
    );
  };
}
